import { apiClient } from './client';

export const REPORT_IMPORT_SECTION_IDS = [
    'demand_description',
    'procedures',
    'behavior_observations',
    'clinical_history',
    'tests',
    'diagnosis',
    'recommendations',
] as const;

export type ReportImportSectionId = (typeof REPORT_IMPORT_SECTION_IDS)[number];

/** What the API may suggest per segment: a section, or an honest "unknown". */
export type ReportImportSuggestionId = ReportImportSectionId | 'unknown';

export type ReportImportSegmentSource = 'lexicon' | 'llm' | 'unknown' | 'preamble';

export interface ReportImportSegment {
    index: number;
    title: string | null;
    /** Title without leading numbering/trailing colon, for editor display. */
    display_title: string | null;
    html: string;
    empty_body: boolean;
    suggested_section: ReportImportSuggestionId;
    confidence: 'high' | 'low';
    source: ReportImportSegmentSource;
}

export interface ReportImportParseResult {
    segments: ReportImportSegment[];
    warnings: string[];
}

export const reportImportsApi = {
    parse: async (key: string, patientId?: string): Promise<ReportImportParseResult> => {
        const response = await apiClient.post<{ data: ReportImportParseResult }>(
            '/report-imports/parse',
            { key, ...(patientId ? { patient_id: patientId } : {}) },
        );
        return (response as unknown as { data: ReportImportParseResult }).data;
    },
};
